import { gql } from '@apollo/client';

// Fragment for CallLog fields
export const CALL_LOG_FIELDS = gql`
  fragment CallLogFields on CallLog {
    id
    clientId
    inquiryId
    staffId
    caseId
    phoneNumber
    contactName
    contactEmail
    startTime
    endTime
    duration
    outcome
    notes
    createdAt
    updatedAt
  }
`;

// Query to get call logs with filtering and pagination
export const GET_CALL_LOGS = gql`
  ${CALL_LOG_FIELDS}
  query ListCallLogs($limit: Int, $nextToken: String, $filter: CallLogFilterInput) {
    listCallLogs(limit: $limit, nextToken: $nextToken, filter: $filter) {
      items {
        ...CallLogFields
        client {
          id
          firstName
          lastName
          email
        }
        inquiry {
          id
          firstName
          lastName
        }
        staff {
          id
          firstName
          lastName
          role
        }
        case {
          id
          caseNumber
        }
      }
      nextToken
    }
  }
`;

// Query to get call metrics
export const GET_CALL_METRICS = gql`
  query GetCallMetrics($startDate: AWSDateTime, $endDate: AWSDateTime) {
    getCallMetrics(startDate: $startDate, endDate: $endDate) {
      totalCalls
      totalCallsToday
      totalCallsThisWeek
      totalCallsThisMonth
      averageDuration
      outcomeDistribution {
        outcome
        count
      }
      callsByStaff {
        staffId
        staffName
        count
      }
    }
  }
`;

// Query to get a single call log
export const GET_CALL_LOG = gql`
  ${CALL_LOG_FIELDS}
  query GetCallLog($id: ID!) {
    getCallLog(id: $id) {
      ...CallLogFields
      client {
        id
        firstName
        lastName
        email
        phoneNumber
      }
      inquiry {
        id
        firstName
        lastName
        email
        phoneNumber
      }
      staff {
        id
        firstName
        lastName
        role
        email
      }
      case {
        id
        caseNumber
      }
    }
  }
`;

// Mutation to create a new call log
export const CREATE_CALL_LOG = gql`
  ${CALL_LOG_FIELDS}
  mutation CreateCallLog($input: CreateCallLogInput!) {
    createCallLog(input: $input) {
      ...CallLogFields
    }
  }
`;

// Mutation to update a call log
export const UPDATE_CALL_LOG = gql`
  ${CALL_LOG_FIELDS}
  mutation UpdateCallLog($id: ID!, $input: UpdateCallLogInput!) {
    updateCallLog(id: $id, input: $input) {
      ...CallLogFields
    }
  }
`;

// Mutation to delete a call log
export const DELETE_CALL_LOG = gql`
  mutation DeleteCallLog($id: ID!) {
    deleteCallLog(id: $id) {
      id
    }
  }
`;

// Query to get call logs by client
export const GET_CALL_LOGS_BY_CLIENT = gql`
  ${CALL_LOG_FIELDS}
  query ListCallLogsByClient($clientId: ID!, $limit: Int, $nextToken: String) {
    listCallLogsByClient(clientId: $clientId, limit: $limit, nextToken: $nextToken) {
      items {
        ...CallLogFields
        staff {
          id
          firstName
          lastName
          role
        }
      }
      nextToken
    }
  }
`;

// Query to get call logs by inquiry
export const GET_CALL_LOGS_BY_INQUIRY = gql`
  ${CALL_LOG_FIELDS}
  query ListCallLogsByInquiry($inquiryId: ID!, $limit: Int, $nextToken: String) {
    listCallLogsByInquiry(inquiryId: $inquiryId, limit: $limit, nextToken: $nextToken) {
      items {
        ...CallLogFields
        staff {
          id
          firstName
          lastName
          role
        }
      }
      nextToken
    }
  }
`;

// Query to get my call logs (for current user)
export const GET_MY_CALL_LOGS = gql`
  ${CALL_LOG_FIELDS}
  query ListMyCallLogs($limit: Int, $nextToken: String) {
    listMyCallLogs(limit: $limit, nextToken: $nextToken) {
      items {
        ...CallLogFields
        client {
          id
          firstName
          lastName
          email
        }
        inquiry {
          id
          firstName
          lastName
        }
      }
      nextToken
    }
  }
`;